import React from "react";
import { CardOption } from "./styles";

const Card = ({ title, selected, onChange, fullWidth }) => {
  return <CardOption fullWidth={fullWidth} selected={selected} onClick={onChange}>{title}</CardOption>;
};
export default Card;
